var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('GlobalNavBar'),_c('b-container',{staticClass:"content"},[_c('b-row',[_c('b-col',{attrs:{"sm":"3"}},[_c('LeftBar')],1),_c('b-col',{attrs:{"sm":"9"}},[_c('router-view')],1)],1)],1),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }